import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getCurrentLocation } from '../location/selectors';
import { getOrganization, getOrganizationSlug } from '../organizations/selectors';
import { getLockerNetworkInterfaces, getMarketNetworkInterfaces, getNetworkInterface, getOrgNetworkInterfaces, getSiteNetworkInterfaces, patchNetworkInterface } from './data';
import { errorReceiveLockerNetworkInterfaces, errorReceiveMarketNetworkInterfaces, errorReceiveModifyNetworkInterface, errorReceiveNetworkInterface, errorReceiveOrgNetworkInterfaces, errorReceiveSiteNetworkInterfaces, failedReceiveLockerNetworkInterfaces, failedReceiveMarketNetworkInterfaces, failedReceiveModifyNetworkInterface, failedReceiveNetworkInterface, failedReceiveOrgNetworkInterfaces, failedReceiveSiteNetworkInterfaces, receiveLockerNetworkInterfaces, receiveMarketNetworkInterfaces, receiveModifyNetworkInterface, receiveNetworkInterface, receiveOrgNetworkInterfaces, receiveSiteNetworkInterfaces } from './slice';
export function* requestLockerNetworkInterfaces(action) {
    try {
        const { deviceId } = action.payload;
        const organizationSlug = yield select(getOrganizationSlug);
        const response = yield call(getLockerNetworkInterfaces, deviceId, organizationSlug);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveLockerNetworkInterfaces());
        }
        else if (data) {
            yield put(receiveLockerNetworkInterfaces(data));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveLockerNetworkInterfaces());
    }
}
export function* requestMarketNetworkInterfaces(action) {
    try {
        const { edgeMarket } = action.payload;
        const organizationSlug = yield select(getOrganizationSlug);
        const response = yield call(getMarketNetworkInterfaces, edgeMarket, organizationSlug);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveMarketNetworkInterfaces());
        }
        else if (data) {
            yield put(receiveMarketNetworkInterfaces(data));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveMarketNetworkInterfaces());
    }
}
export function* requestOrgNetworkInterfaces() {
    try {
        const organizationSlug = yield select(getOrganizationSlug);
        const response = yield call(getOrgNetworkInterfaces, organizationSlug);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveOrgNetworkInterfaces());
        }
        else if (data) {
            yield put(receiveOrgNetworkInterfaces(data));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveOrgNetworkInterfaces());
    }
}
export function* requestModifyNetworkInterface(action) {
    try {
        const { description, deviceId, interfaceId } = action.payload;
        const location = yield select(getCurrentLocation);
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchNetworkInterface, location, organization, deviceId, interfaceId, description);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveModifyNetworkInterface());
            yield put(appDanger(t('ERROR_REQUEST_MODIFY_NETWORK_INTERFACE', {
                ns: 'Common'
            })));
        }
        else if (data) {
            yield put(receiveModifyNetworkInterface(data));
            yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_NETWORK_INTERFACE', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('FAILED_REQUEST_MODIFY_NETWORK_INTERFACE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveModifyNetworkInterface());
    }
}
export function* requestNetworkInterface(action) {
    try {
        const { deviceId, interfaceId } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getNetworkInterface, organization, deviceId, interfaceId);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveNetworkInterface());
        }
        else if (data) {
            yield put(receiveNetworkInterface(data));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveNetworkInterface());
    }
}
export function* requestSiteNetworkInterfaces(action) {
    try {
        const { locationSlug } = action.payload;
        const organization = yield select(getOrganization);
        const response = yield call(getSiteNetworkInterfaces, organization, locationSlug);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveSiteNetworkInterfaces());
        }
        else if (data) {
            yield put(receiveSiteNetworkInterfaces(data));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveSiteNetworkInterfaces());
    }
}
export function* watchRequestLockerNetworkInterfaces() {
    yield takeLatest('networkInterfaces/requestLockerNetworkInterfaces', requestLockerNetworkInterfaces);
}
export function* watchRequestMarketNetworkInterfaces() {
    yield takeLatest('networkInterfaces/requestMarketNetworkInterfaces', requestMarketNetworkInterfaces);
}
export function* watchRequestModifyNetworkInterface() {
    yield takeLatest('networkInterfaces/requestModifyNetworkInterface', requestModifyNetworkInterface);
}
export function* watchRequestNetworkInterface() {
    yield takeLatest('networkInterfaces/requestNetworkInterface', requestNetworkInterface);
}
export function* watchRequestOrgNetworkInterfaces() {
    yield takeLatest('networkInterfaces/requestOrgNetworkInterfaces', requestOrgNetworkInterfaces);
}
export function* watchRequestSiteNetworkInterfaces() {
    yield takeLatest('networkInterfaces/requestSiteNetworkInterfaces', requestSiteNetworkInterfaces);
}
